module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": [{
        name: 'Groups'
      }, {
        name: 'Messaging'
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("Send a Message")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn green pull-right",
    attrs: {
      "to": {
        name: 'Send Message'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                    Continue\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("Message History")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn green pull-right",
    attrs: {
      "to": {
        name: 'Message History'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                    Continue\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Messaging")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e8ac962","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Messaging/Home.vue
// module id = 1555
// module chunks = 1